export default "__VITE_ASSET__DM5fflE6__"